import { FieldGroupsByLocatorMap } from '../../../types/policy';
import { getCharacteristic } from '../../../util/util';
import {
	removePendingRemoveFieldGroupsLocatorsFromFieldValues,
	updateFieldGroupsByLocatorWithPendingChanges,
} from '../../policy/util_sharedEndorsementAndRenewal';
import { FORM_NAME } from '../data/constants';
import { EndorsementFormTransformer, FormBuilder, FormShape } from '../types';

const getEndorsementsForm = (
	props: EndorsementFormTransformer,
	name = FORM_NAME.ENDORSEMENT_FORM as keyof FormShape<FormBuilder>,
) => {
	const { endorsementData } = props;
	const { productConfig, policy, endorsementUpdateObj } = endorsementData;
	const { policyConfiguration } = productConfig;
	const endorsementEffectiveDate = endorsementUpdateObj.startTimestamp;
	const { characteristics } = policy;

	const characteristic = getCharacteristic(
		characteristics,
		endorsementEffectiveDate,
	);

	const policyFieldValues = characteristic.fieldValues;
	const endorsementFieldValues = endorsementUpdateObj.fieldValues;

	const policyFieldGroupsByLocator = characteristic.fieldGroupsByLocator;
	const mediaByLocator = characteristic.mediaByLocator;

	const pendingUpdateFieldGroups = endorsementUpdateObj.updateFieldGroups;
	const addFieldGroups = endorsementUpdateObj.addFieldGroups;
	const pendingRemoveFieldGroups = endorsementUpdateObj.removeFieldGroups;
	const values = removePendingRemoveFieldGroupsLocatorsFromFieldValues(
		pendingRemoveFieldGroups,
		{ ...policyFieldValues, ...endorsementFieldValues },
	);

	const { fields, externalDataCalls } = policyConfiguration;

	const fieldGroupsByLocator: FieldGroupsByLocatorMap =
		updateFieldGroupsByLocatorWithPendingChanges(
			policyFieldGroupsByLocator,
			pendingUpdateFieldGroups,
			pendingRemoveFieldGroups,
		);

	return {
		[name]: {
			fields,
			fieldGroupsByLocator,
			addFieldGroups,
			mediaByLocator,
			externalDataCalls,
			values,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export default getEndorsementsForm;
